import * as React from 'react';
import StartBom from './CreateBom/StartBom';
import FindBom from './CreateBom/FindBom';
import BomList from './CreateBom/BomList';
import ProjectList from './CreateBom/ProjectList'
import SystemAlerts from "src/component/SystemAlerts";
import { useBOMProjectStore } from "src/hooks/bom_project";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

export function BOM() {
    const [{ your_bom_listing }, { }, { }] = useBOMProjectStore();
    const [{ latest_system_notification_data }, { }, { }] = useDOMAttachToSystemStore();

    return (
        <>
            <div className="logged-screen">
                <div className="">
                    <div id="main" className="">
                        <div className="bom-page">
                            <div className="container">
                                <div
                                    className="bom-page-head header-container d-flex align-items-center justify-content-between">
                                    <div className="page-title font-oswald font-light font-30">BOMs</div>
                                </div>
                                <div className="pcn-line-divider" />

                                {latest_system_notification_data.errorModule !== undefined && latest_system_notification_data.errorModule !== 'bomUpload' &&
                                    latest_system_notification_data.errorModule !== 'downloadBOM' &&
                                    <SystemAlerts />
                                }

                                <StartBom />

                                <FindBom />

                                {latest_system_notification_data.errorModule !== undefined &&
                                    latest_system_notification_data.errorModule === 'downloadBOM' &&
                                    <>
                                        <div className='mt-2'>
                                            <SystemAlerts />
                                        </div>
                                    </>
                                }

                                <DndProvider backend={HTML5Backend}>

                                    <BomList bom_listing={your_bom_listing} />

                                    <ProjectList />

                                </DndProvider>

                                <div className="m-t-20 m-b-20 font-13">Avnet reserves the right to remove a BOM after 180
                                    days of non-use
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );

}
